// API URL is derived from window.location.origin at runtime
// This works for all environments: dev (via CRA proxy), staging, production
export const API_URL = typeof window !== 'undefined'
  ? window.location.origin
  : 'https://hereabout.app';

// WebSocket URL - in dev mode (port 3000), connect directly to backend
// In production, use the same origin
export const WS_BASE_URL = typeof window !== 'undefined' && window.location.port === '3000'
  ? 'http://localhost:5002'
  : API_URL;

export const STREAM_API_KEY = 'z93jj8wh66r4'; // TODO: move to env
